module.exports = __webpack_public_path__ + "static/img/sidney.16097e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/sidney.jpg
// module id = 6W09
// module chunks = 1